import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

export interface IDepositTransaction {
  id?: string;
  customerAccountNo?: string;
  customerAccountName?: string;
  clientId?: string;
  amount?: string;
  transactionReferenceId?: string;
  clientIdValidationToken?: string;
  clientIdValidationStatus?: string;
  clientIdValidationResponse?: string;
  transactionStatus?: string;
  postingsStatus?: string;
  postingsResponse?: string;
  providerStatus?: string;
  providerResponse?: string;
  reversalStatus?: string;
  reversalResponse?: string;
  reversalTryCount?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface IGetDepositsResponse {
  status?: boolean;
  message?: string;
  data?: {
    page?: number;
    total?: number;
    dataSize?: number;
    transactions?: IDepositTransaction[];
  };
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetDepositsResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getDepositsAsync = createAsyncThunk(
  'bet9ja/deposits',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const customerAccountNumber = localStorage.getItem('accountNumber');

      const { data } = await api.get(
        `/bet9ja/deposits/${customerAccountNumber}/transactions`,
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const depositsGetSlice = createSlice({
  name: 'bet9ja/deposits/get',
  initialState,
  reducers: {
    resetGetDeposits: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDepositsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getDepositsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetDepositsResponse;
      })
      .addCase(getDepositsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetDepositsResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetDeposits } = depositsGetSlice.actions;

export default depositsGetSlice.reducer;
